import React, { Fragment } from "react";

import TableContainer from "@material-ui/core/TableContainer";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import format from "date-fns/format";
import { HomeWork, Cancel } from "@material-ui/icons";

import cardBodyStyle from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const StyledTableRow = withStyles((theme) => ({
  root: {
    width: "100%",
    "&:nth-of-type(odd)": {
      backgroundColor: "#FAFAFA",
    },
  },
}))(TableRow);

function createData(name, data) {
  return { name, data };
}

export default function ViewPreRegistration(props) {
  const classes = useStyles();

  const rows2 = [
    createData("Negocio", props.id.name),
    createData("Persona contacto", props.id.contact),
    createData("Teléfono", props.id.phone),
    createData("Correo electrónico", props.id.email),
    createData(
      "Organización",
      props.id.organization_type_name !== "Otros"
        ? props.id.organization_type_name
        : props.id.organization_type_another === null
        ? props.id.organization_type_name
        : props.id.organization_type_another + " (Otros)"
    ),
    createData(
      "Sector económico",
      props.id.economic_sector_name !== "Otros"
        ? props.id.economic_sector_name
        : props.id.economic_sector_another === null
        ? props.id.economic_sector_name
        : props.id.economic_sector_another + " (Otros)"
    ),
    createData(
      "Fecha creación",
      format(new Date(props.id.date_created), "dd-MM-yyyy kk:mm:ss")
    ),
  ];

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        scroll="body"
        keepMounted
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <center>
                <HomeWork style={{ fontSize: 48 }} />
              </center>
            </Grid>
            <Grid item xs={12} md={12}>
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableBody>
                    {rows2.map((row) => (
                      <StyledTableRow key={row.name}>
                        <TableCell component="th" scope="row">
                          <b>{row.name}</b>
                        </TableCell>
                        <TableCell>{row.data}</TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            <Grid item xs={12} md={6}>
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableBody>
                    <TableCell component="th" scope="row" colSpan="2">
                      <center>
                        <b>Recursos que tengo</b>{" "}
                      </center>
                    </TableCell>
                    {props.id.hasList.map((row, index) => (
                      <StyledTableRow key={row.id}>
                        <TableCell>
                          {row.has_name !== "Otros"
                            ? row.has_name
                            : row.another === null
                            ? row.has_name
                            : row.another + " (Otros)"}
                        </TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableBody>
                    <TableCell component="th" scope="row" colSpan="2">
                      <center>
                        <b>Recursos que Necesito</b>{" "}
                      </center>
                    </TableCell>
                    {props.id.needsList.map((row, index) => (
                      <StyledTableRow key={row.id}>
                        <TableCell>
                          {row.need_name !== "Otros"
                            ? row.need_name
                            : row.another === null
                            ? row.need_name
                            : row.another + " (Otros)"}
                        </TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item xs={12} sm={12}>
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableBody>
                    <TableCell component="th" scope="row" colSpan="2">
                      <center>
                        <b>Residuos que genera su sector</b>{" "}
                      </center>
                    </TableCell>
                    {props.id.wastesList.map((row, index) => (
                      <StyledTableRow key={row.id}>
                        <TableCell>
                          {row.waste_name !== "Otros"
                            ? row.waste_name
                            : row.another === null
                            ? row.waste_name
                            : row.another + " (Otros)"}
                        </TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
